import { mutationOptions } from '@tanstack/react-query';

import type { GymFinderService } from 'app/features/leads/services/gym-finder';
import type { UpdateLeadStatusParams } from 'app/features/leads/services/gym-finder/types';

type LeadStatusUpdateService = Pick<GymFinderService, 'updateLeadStatus'>;

export const updateLeadStatusMutationOptions = (service: LeadStatusUpdateService) =>
  mutationOptions({
    mutationFn: ({ id, status }: UpdateLeadStatusParams) => service.updateLeadStatus(id, status),
  });
